<bz-loading class="bmc-rpa-job__loading" size="xl" *ngIf="isLoading">
</bz-loading>

<div class="bmc-rpa-job__dashboard" *ngIf="dataJobsChart && !isLoading" [style.display]="dataJobsChart?'':'none'">
    <ul class="bmc-rpa-job__items">
        <li class="bmc-rpa-job__item">
            <bz-pie-chart [tabIndex]="tabIndex" [myIndex]="0" [idChart]="'canvasJobsld'" [dataChart]="dataChartJobStatusLastDay" [title]="'RPA_BOTS.LAST_24_HOURS' | translate"></bz-pie-chart>
        </li>
        <li class="bmc-rpa-job__item">
            <bz-pie-chart [tabIndex]="tabIndex" [myIndex]="0" [idChart]="'canvasJobslw'" [dataChart]="dataChartJobStatusLastWeek" [title]="'RPA_BOTS.LAST_7_DAYS' | translate"></bz-pie-chart>
        </li>
    </ul>

    <ul class="bmc-rpa-job__items">
        <li class="bmc-rpa-job__item">
            <bz-pie-chart [tabIndex]="tabIndex" [myIndex]="0" [idChart]="'canvasJobslm'" [dataChart]="dataChartJobStatusLastMonth" [title]="'RPA_BOTS.LAST_30_DAYS' | translate"></bz-pie-chart>
        </li>
        <li class="bmc-rpa-job__item">
            <bz-line-chart [tabIndex]="tabIndex" [myIndex]="0" [idChart]="'canvasJobsly'" [dataChart]="dataChartJobStatusLastYear" [title]="'RPA_BOTS.LAST_YEAR' | translate"></bz-line-chart>
        </li>
    </ul>
</div>

<div class="no-data" *ngIf="!dataJobsChart && !isLoading" >
  {{ 'RPA_BOTS.NO_DATA_AVAILABLE' | translate }}
</div>
